import { Component, inject, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { TranslatePipe } from '@ngx-translate/core';
import { LanguageService } from '../../../../core/services/language/language.service';

@Component({
  selector: 'app-link-registration',
  imports: [TranslatePipe],
  templateUrl: './link-registration.html',
  styleUrl: './link-registration.scss'
})
export class LinkRegistration implements OnInit {
  link_now: string = '';
  language = inject(LanguageService);

  ngOnInit(): void {
    this.link_now =  environment.linkCabinetRegistration;
  }

  nowLinkSignUp():string{
    let link = `${environment.linkCabinet}${this.language.appLanguage}/signup`;
    return link;
  }
}
